/**
 * @generated SignedSource<<93ee341882a8775580eaac9896eeaa00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedeemBanner_target$data = {
  readonly panelistCost: {
    readonly subUnitAmount: number;
  };
  readonly redemptionAmount: {
    readonly formatted: string;
  };
  readonly " $fragmentType": "RedeemBanner_target";
};
export type RedeemBanner_target$key = {
  readonly " $data"?: RedeemBanner_target$data;
  readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_target">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RedeemBanner_target",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "panelistCost",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "redemptionAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AmountDenomination",
  "abstractKey": null
};

(node as any).hash = "dd2b537f13e76e2ae0e84c71a77b855f";

export default node;
